import React, { FC } from 'react'
import styled from 'styled-components'
import { Box, Text, useBreakpointValue } from '@chakra-ui/react'
import { Container } from 'src/components'
import { ArrowDownIcon } from 'src/icons'
import Carousel from '../common/Carousel'
import Service from './Service'

interface Props {
  title: string
  services: Array<OfferGlobal.Service>
}

const Title = styled.div`
  text-align: center;
  margin-top: 2.5rem;
  margin-bottom: 3rem;
  & svg {
    margin: auto;
  }
`

const ServiceItemContainer = styled.div`
  ul {
    margin-left: 18px;
    margin-top: 8px;
  }
`

const ServicesList: FC<Props> = ({ title, services }) => {
  const isMobile = useBreakpointValue({ base: true, md: false })

  return <Box bg="baseNeutral.800" pb="1.375rem">
    <Container paddingY="0">
      <Title>
        <ArrowDownIcon />
        <Text
          as="h2"
          mx="2"
          marginTop="m"
          fontFamily="Montserrat-SemiBold"
          fontSize="1.5rem"
          lineHeight="31px"
          letterSpacing=".68px"
          textAlign="center"
          color="baseWhite"
        >
          {title}
        </Text>
      </Title>
      <Carousel
        withCustomNavigation={!isMobile}
        breakpoints={{
          320: {
            slidesPerView: 1.3,
            spaceBetween: 18,
            centeredSlides: true
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        }}
        withScrollbar
        className="offer-service-carousel"
      >
        {services.map(service => {
          return (
            <Carousel.Item key={service.slug}>
              <ServiceItemContainer>
                <Service
                  name={service.name}
                  slug={service.slug}
                  description={service.description}
                  icon={service.icon}
                />
              </ServiceItemContainer>
            </Carousel.Item>
          )
        })}
      </Carousel>
    </Container>
  </Box>
}

export default ServicesList
